<ion-content>
  <h4>{{titulo}}</h4>
  <h6>{{subtitulo}}</h6>
  <h6>{{trab|uppercase}}</h6>
  <div class="pin">
    <ion-icon [name]="icon(1)" size="large" mode="ios"></ion-icon>
    <ion-icon [name]="icon(2)" size="large" mode="ios"></ion-icon>
    <ion-icon [name]="icon(3)" size="large" mode="ios"></ion-icon>
    <ion-icon [name]="icon(4)" size="large" mode="ios"></ion-icon>
  </div>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button mode="ios" color="light" fill="outline" shape="round" (click)="handleInput('1')">1</ion-button>
      </ion-col>
      <ion-col>
        <ion-button mode="ios" color="light" fill="outline" shape="round" (click)="handleInput('2')">2</ion-button>
      </ion-col>
      <ion-col>
        <ion-button mode="ios" color="light" fill="outline" shape="round" (click)="handleInput('3')">3</ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button mode="ios" color="light" fill="outline" shape="round" (click)="handleInput('4')">4</ion-button>
      </ion-col>
      <ion-col>
        <ion-button mode="ios" color="light" fill="outline" shape="round" (click)="handleInput('5')">5</ion-button>
      </ion-col>
      <ion-col>
        <ion-button mode="ios" color="light" fill="outline" shape="round" (click)="handleInput('6')">6</ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button mode="ios" color="light" fill="outline" shape="round" (click)="handleInput('7')">7</ion-button>
      </ion-col>
      <ion-col>
        <ion-button mode="ios" color="light" fill="outline" shape="round" (click)="handleInput('8')">8</ion-button>
      </ion-col>
      <ion-col>
        <ion-button mode="ios" color="light" fill="outline" shape="round" (click)="handleInput('9')">9</ion-button>
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <ion-col class="cancel">
        <ion-icon name="close-circle" color="light" (click)="handleInput('cancel')"></ion-icon>
      </ion-col>
      <ion-col>
        <ion-button mode="ios" color="light" fill="outline" shape="round" (click)="handleInput('0')">0</ion-button>
      </ion-col>
      <ion-col>
        @if (modo === 'pin') {
          <ion-button color="light" fill="clear" (click)="handleInput('change')">
            <ion-icon mode="md" slot="icon-only" name="keypad"></ion-icon>
          </ion-button>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
